
export const annualOptions = [
    {
      text: '2022',
      value: 2022,
    },
    {
      text: '2021',
      value: 2021,
    },
    {
      text: '2020',
      value: 2020,
    },
    {
      text: '2019',
      value: 2019,
    },
  ];

  //地图参数
  export const mapColor = [
    '#EBECF1',
    '#5086f333',
    '#5086F359',
    '#5086F380',
    '#5086F3a6',
    '#5086F3cc',
    '#5086F3',
  ];

   //手游地图数据切换选项
  export const segmentOptionsMobile = [
    {
      text: 'Revenue($)',
      value: 'Revenue',
    },
    {
      text: 'Downloads',
      value: 'Downloads',
    },
  ];

  export const lineColor = [
    '#376AE7',
    '#3ECBFF',
    '#4FCB87',
    '#FFD14E',
    '#ED9142',
    '#E95F6A',
    '#CF61AC',
    '#8164CD',
    '#6585F7',
    '#A0B6FA',
  ];

  export const getSortType = (type:string,pageId:string) => {
    switch (type) {
      case 'revenue':
        return 'marketRevenue';
      case 'revenueChange':
        return 'marketRevenuePrecent';
      case 'downloads':
        return 'marketDownloads';
      case 'downloadsChange':
        return 'marketDownloadsPrecent';
      case 'digital':
        return 'marketDigitalRevenue';
      case 'digitalChange':
        return 'marketDigitalRevenuePrecent';
      case 'physical':
        return 'marketPhysicalRevenue';
      case 'physicalChange':
        return 'marketPhysicalRevenuePrecent';
      case 'totalRevenue':
        return pageId == 'MarketProfilPC' ? 'pcRevenue' : 'consoleRevenue';
      case 'totalPlayer':
        return pageId == 'MarketProfilPC' ? 'pcPlayer' : 'consolePlayer';
      case 'annualRevenue':
        return 'marketRevenue';
      case 'annualRevenueChange':
        return 'marketRevenuePrecent';
      case 'gameCount':
        return 'gameCount';
      case 'gameCountChange':
        return 'gameCountPrecent';
      default:
        return '';
    }

  }

  //marketProfile-突增游戏的info提示
  export const MARKETBIGRISERGAMESTIP = {
    marketProfileMobile: {
      en: 'Big Riser Games are games that have entered the top list of App Store Ranks for the first time.',
      cn: '突增游戏(Big Riser Games)取自首次进入App Store商店各榜单的游戏。',
    },
    marketProfilePc: {
      en: 'Big Riser Games are games that entered the top list of Steam Top Seller, Mscience digital revenue, and MAU for the first time.',
      cn: '突增游戏(Big Riser Games)取自首次进入Steam Top Seller榜单、Mscience收入排名头部以及MAU排名头部的游戏。',
    },
    marketProfileConsole: {
      en: 'Big Riser Games are games that entered the top list of Store Ranks such as PS Best Selling, PS Most Downloaded, Xbox Most Played, and Xbox New Release.',
      cn: '突增游戏(Big Riser Games)取自首次进入PS Best Selling榜单、PS Most Downloaded榜单、Xbox Most Played榜单、Xbox New Release榜单的游戏。',
    },
  }

  //P.Heat值info信息调整--末尾新增信息
export const PHEAT_NEW_TIP = `The parameter factors of P.Heat value include national weight and game category, as well as the past performance of developers and publishers, such as revenue and download data. PC games are also influenced by Steam Top Wishlist.`